// WARNING! be cautious editing this component, it is used by all the auto-generated illustrations.
import React from 'react'
import cx from 'classnames'

type IllustrationAccessibility = 'decorative' | 'semantic'

export type IllustrationProps = {
  className?: string
  testId?: string
  title?: string
  accessibility?: IllustrationAccessibility
  resizeToContainer?: boolean
}

export const IllustrationWrapper = React.forwardRef<
  HTMLDivElement,
  React.PropsWithChildren<IllustrationProps>
>((props, ref) => {
  const {
    children,
    className,
    testId,
    accessibility = 'decorative',
    // eslint-disable-next-line
    resizeToContainer, //(removing from ...restProps)
    ...restProps
  } = props

  const accessibilityProps =
    accessibility === 'decorative' ? { 'aria-hidden': true } : { role: 'img' }

  return (
    <div
      className={cx('inline-block leading-none', className)}
      data-testid={testId}
      {...accessibilityProps}
      {...restProps}
      ref={ref}
    >
      {children}
    </div>
  )
})
